import { apiRequest } from "./client";

export async function getUsers() {
  const response = await apiRequest("/api/v1/users");
  return response.json();
}

export async function getMe() {
  const response = await apiRequest("/api/v1/users/me");
  return response.json();
}

export async function updateMe(profile) {
  const response = await apiRequest("/api/v1/users/me", {
    method: "PUT",
    body: JSON.stringify(profile),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || "プロフィールの更新に失敗しました。");
  }
  return response.json();
}

export async function getMyTemplateSettings() {
  const response = await apiRequest("/api/v1/users/me/template-settings");
  if (!response.ok) {
    throw new Error("テンプレート利用設定の取得に失敗しました。");
  }
  return response.json();
}

export async function updateMyTemplateSettings(settings) {
  const response = await apiRequest("/api/v1/users/me/template-settings", {
    method: "PUT",
    body: JSON.stringify({ settings }),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || "テンプレート利用設定の更新に失敗しました。");
  }
  return response.json();
}
